import * as React from "react";
import * as RadixCheckbox from "@radix-ui/react-checkbox";
import clsx from "clsx";
import { CheckIcon } from "./check-icon";

export interface CheckboxProps extends React.ComponentPropsWithoutRef<typeof RadixCheckbox.Root> {
  label?: React.ReactNode;
}

export const Checkbox = React.forwardRef<HTMLButtonElement, CheckboxProps>(
  ({ checked, onCheckedChange, label, className, ...props }, ref) => (
    <label className="inline-flex items-center gap-2 cursor-pointer text-sm">
      <RadixCheckbox.Root
        ref={ref}
        checked={checked}
        onCheckedChange={onCheckedChange}
        className={clsx(
          "w-4 h-4 rounded border border-gray-300 bg-card flex items-center justify-center transition-colors focus:outline-none focus:ring-2 focus:ring-primary hover:bg-card-50",
          "data-[state=checked]:bg-primary data-[state=checked]:border-primary data-[state=checked]:text-white",
          "dark:border-gray-600 dark:bg-card-800 dark:data-[state=checked]:text-black",
          className
        )}
        {...props}
      >
        <RadixCheckbox.Indicator className="flex items-center justify-center w-full h-full">
          <CheckIcon size={12} variant="checkbox" />
        </RadixCheckbox.Indicator>
      </RadixCheckbox.Root>
      {label && <span>{label}</span>}
    </label>
  )
);
Checkbox.displayName = "Checkbox";
